import Cookies from 'js-cookie'
import router from "../../router"
import { handleResponse } from '../../services/response.js';
import { getCookieDomain } from "../../utils/domain";

const url = import.meta.env.VITE_APP_API_AUTH
const authTokenName = import.meta.env.VITE_APP_AUTH_TOKEN_NAME
const refreshTokenName = import.meta.env.VITE_APP_REFRESH_TOKEN_NAME

function initAuthTokens() {

    let additionalAuthToken = Cookies.get(authTokenName, { domain: getCookieDomain() })
    let additionalRefreshToken = Cookies.get(refreshTokenName, { domain: getCookieDomain() })
    if(additionalAuthToken !== undefined && additionalRefreshToken !== undefined) {
        return {auth_token: additionalAuthToken, refresh_token: additionalRefreshToken}
    }

    let baseAuthToken = Cookies.get(authTokenName, { domain: getCookieDomain() })
    let baseRefreshToken = Cookies.get(refreshTokenName, { domain: getCookieDomain() })
    if(baseAuthToken === undefined || baseRefreshToken === undefined) {
        return null
    }
    return {auth_token: baseAuthToken, refresh_token: baseRefreshToken}
}

export default {
    actions: {
        fetchAuth({ dispatch, commit, getters, rootGetters }, data = { url : null, option: {}, action:{}, manualCall: false}) {
            const isGuest = getters.isGuest
            const actionQueue = getters.getActionQueue

            if(isGuest) {
                router.push('/')
                return
            }
            if(data.manualCall !== undefined && actionQueue.length) {
                commit("SET_ADD_ACTION_QUEUE", {name: data.action.name, data: data.action.data})
                return {code: 401, data: {}}
            }
            const authHeader = getters.getAuthHeader

            let option = data.option ?? {}
            option.headers = {...option.headers, ...authHeader}
            return fetch(data.url, option).then(response => {
                return response.text().then(text => {
                    const result = text && JSON.parse(text)
                    if (!response.ok) {
                        if(result.code === 200 || result.code === 422) {
                            return result
                        } else if(result.code === 401) {
                            commit("SET_ADD_ACTION_QUEUE", {name: data.action.name, data: data.action.data})
                            dispatch("refreshTokens")
                            return result
                        } else {
                            const error = (result && result.message) || response.statusText
                            throw new Error(error)
                        }
                    }
                    return result;
                })
            })
        },
        async refreshTokens({ dispatch, commit, getters }) {
            const tokenStatus = getters.getTokenStatus
            const authTokens = getters.getAuthTokens
            if(tokenStatus || authTokens == null) {
                return
            }
            commit("SET_TOKEN_UPDATE_STATUS", true)
            const authHeader = getters.getAuthHeader
            return fetch(`${url}/identity/refresh-token/${authTokens.refresh_token}`, {
                method: 'POST',
                referrer: "",
                redirect: 'manual',
                headers: {...{'Content-Type': 'application/json'}, ...authHeader},
            })
                .then(response => response.json())
                .then(result => {
                    if (result.code === 200) {
                        commit("SET_AUTH_TOKENS", result.data)
                        const actionQueue = getters.getActionQueue
                        if(actionQueue.length) {

                            actionQueue.forEach(action => {
                                dispatch(action.name, action.data, {root: true})
                            })
                            commit("SET_CLEAR_ACTION_QUEUE")
                        }
                    } else {
                        commit("SET_CLEAR_AUTH_TOKENS")
                    }
                })
        },

        async login({ dispatch, commit, getters }, data = {} ) {
            const oauth = data.oauth
            delete data.oauth
            if(!getters.isGuest) {
                window.location.href = '/'
                return
            }

            return fetch(`${url}/identity/authentication`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept-Language': getters.getAppLanguage},
                body: JSON.stringify(data)
            }).then(handleResponse)
                .then(result => {
                    if(result.code === 200 && result.data.auth_token) {
                        commit("SET_AUTH_TOKENS", result.data)
                        dispatch("identification", result.data)


                        if(oauth !== undefined) {
                            dispatch("oauth2",oauth);
                        } else {
                            window.location.href = '/'
                        }
                    } else if(result.code !== 202) {
                        commit("SET_CLEAR_AUTH_TOKENS")
                    }
                    return result;
                })
        },
        async oauth2({ dispatch, commit, getters }, params = "" ) {
            return dispatch("fetchAuth", {
                url: `${url}/oauth2?${params}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "oauth2", data: {}}
            }).then(
                result => {
                    if(result.code === 200 && result.data.redirect_url) {
                        window.location.href = result.data.redirect_url
                    }
                    throw Error("An internal error has occurred")
                },
                error => {
                    throw Error(error.message)
                })
            return fetch(`${url}/oauth2?${getParams}`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept-Language': getters.getAppLanguage},
                body: JSON.stringify(data)
            }).then(handleResponse)
                .then(result => {
                    if(result.code === 200) {
                        if(result.data.auth_token) {
                            commit("SET_AUTH_TOKENS", result.data)
                            dispatch("identification", result.data)
                        }
                        if(result.data.location !== undefined) {
                            window.location.href = result.data.redirect_url
                        } else {
                            router.push('/')
                        }
                    } else if(result.code !== 202) {
                        commit("SET_CLEAR_AUTH_TOKENS")
                    }
                    return result;
                })
        },
        loginTwoFa({ dispatch, commit, getters },  {hash, code} ) {
            if(!getters.isGuest) {
                router.push('/')
                return
            }
            return fetch(`${url}/identity/two-fa-auth?hash=${hash}&code=${code}`,
                {headers: {'Content-Type': 'application/json','Accept-Language': getters.getAppLanguage}})
                .then(handleResponse)
                .then(result => {
                    if (result.data.auth_token) {
                        commit("SET_AUTH_TOKENS", result.data)
                        dispatch('identification', result.data)
                        router.push('/')
                    } else {
                        commit("SET_CLEAR_AUTH_TOKENS")
                    }
                    return result;
                })
        },
        async identification({ dispatch, commit, getters } ) {

            return dispatch("fetchAuth", {
                url: `${url}/identity/identification`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "identification", data: {}}
            }).then(result => {
                if(result.code === 200) {
                    commit('SET_USER', result.data)
                    return result.data
                }
            })
        },
        async logout({commit }) {
            commit("SET_CLEAR_AUTH_TOKENS")
        },
        async loginByToken({ dispatch, commit, getters }, data = {} ) {
            commit("SET_AUTOLOGIN_AUTH_TOKENS", data)
        },


        fetchUserProfile: async ({ commit, dispatch }) => {
            commit("SET_USER_PROFILE_LOADING_STATUS", true)
            return dispatch("fetchAuth", {
                url: `${url}/security/get-profile`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchProfile", data: {}}
            }).then(
                result => {
                    if(result.code === 200) {
                        commit("SET_USER_PROFILE_DATA", {
                            username: result.data.username,
                            firstName: result.data.first_name,
                            lastName: result.data.last_name,
                            email: result.data.email,
                            timezone: result.data.timezone,
                            phone: result.data.phone,
                            allow_trade: result.data.allow_trade,
                            allow_credit: result.data.allow_credit,
                            allow_trading_bot: result.data.allow_trading_bot,
                        })
                    }
                    commit("SET_USER_PROFILE_LOADING_STATUS", false)
                },
                error => {
                    commit("SET_USER_PROFILE_LOADING_STATUS", false)
                    // throw Error(error.message)
                })
        },
    },
    mutations: {
        SET_CLEAR_AUTH_TOKENS(state) {
            state.authTokens = null
            let additionalAuthToken = Cookies.get(authTokenName + '_additional', { domain: getCookieDomain() })

            if(additionalAuthToken !== undefined) {
                Cookies.remove(authTokenName + '_additional', { path: '/',  domain: getCookieDomain() })
                Cookies.remove(refreshTokenName + '_additional', { path: '/', domain: getCookieDomain() })
            } else {
                Cookies.remove(authTokenName, { path: '/',  domain: getCookieDomain() })
                Cookies.remove(refreshTokenName, { path: '/', domain: getCookieDomain() })
            }

        },
        SET_AUTH_TOKENS(state, data) {
            state.authTokens = data
            Cookies.set(authTokenName, data.auth_token,  { domain: getCookieDomain() })
            Cookies.set(refreshTokenName, data.refresh_token, { domain: getCookieDomain() })
        },
        SET_AUTOLOGIN_AUTH_TOKENS(state, data) {
            let authToken = Cookies.get(authTokenName, { domain: getCookieDomain() })
            Cookies.set(authTokenName, data.auth_token,  { domain: getCookieDomain() })
            Cookies.set(refreshTokenName, data.refresh_token, { domain: getCookieDomain() })
            /* if(authToken === undefined) {
                 Cookies.set(authTokenName, data.auth_token,  { domain: getCookieDomain })
                 Cookies.set(refreshTokenName, data.refresh_token, { domain: getCookieDomain })
             } else {
                 Cookies.set(authTokenName + '_additional', data.auth_token,  { domain: getCookieDomain })
                 Cookies.set(refreshTokenName + '_additional', data.refresh_token, { domain: getCookieDomain })
             }*/
            state.authTokens = data
        },
        SET_ADD_ACTION_QUEUE(state, data) {
            state.actionQueue.push(data)
        },
        SET_CLEAR_ACTION_QUEUE(state) {
            state.actionQueue = []
        },
        SET_TOKEN_UPDATE_STATUS(state, status) {
            state.tokenStatus = status
        },
        SET_USER(state, data) {
            state.user = data
        },
        SET_USER_PROFILE_LOADING_STATUS(state, status) {
            state.userProfileLoadingStatus = status
        },
        SET_USER_PROFILE_DATA(state, data) {
            state.userProfileData = data
        },

    },
    state: {
        userProfileLoadingStatus: false,
        authTokens: initAuthTokens(),
        actionQueue: [],
        tokenStatus: false,
        user: null,
        userProfileData: undefined,
    },
    getters: {
        getAuthTokens:(state) => state.authTokens,
        isGuest:(state) => state.authTokens == null,
        getUser:(state) => state.user,
        getUserProfileLoadingStatus:(state) => state.userProfileLoadingStatus,
        getUserProfileData:(state) => state.userProfileData,
        getActionQueue:(state) => state.actionQueue,
        getTokenStatus:(state) => state.tokenStatus,
        getAuthHeader:(state) => {
            let user = state.authTokens
            if (user !== null && user.auth_token !== undefined) {
                return {'Authorization': 'Bearer ' + user.auth_token }
            }
            return {}
        },
        getUserTimeZone:(state) => state.userProfileData != undefined && state.userProfileData.timezone !== ""? state.userProfileData.timezone : "GMT"
    }
}